import React from 'react';
import './Sobre.css';
// import imagemSobre from '../../assets/images/imagemSobre.jpg';
import Title from '../../components/title/Title';

const Sobre = props => {
    return (
        <div className="background">
            <Title title="Sobre nós" />
            <div className="container">
            <div className="content">
                <div className="question">Estamos em construção...</div>
                </div>
                {/* <div className="content">
                    <div className="row">
                        <img src={imagemSobre} alt='' />
                        <div className="text">Lorem ipsu Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor  dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor Lorem ipsum dolor</div>
                    </div>
                </div> */}
            </div>
        </div>
    )
};

export default Sobre;